import { Form, FormSelectProps } from "react-bootstrap";
import { UseFormRegister } from "react-hook-form";

interface ISelectOption {
  value: string;
  label?: string;
}

interface Props extends FormSelectProps {
  optionArr: ISelectOption[];
  label?: string;
  labelClassname?: string;
  register?: UseFormRegister<any>;
  registerOpt?: any;
}

export const CustomStaticSelect: React.FC<Props> = (props) => {
  const {
    optionArr,
    register,
    registerOpt = {},
    label,
    labelClassname,
    className: selectClassName,
    ...formSelectProps
  } = props;

  return (
    <div className="custom-static-select">
      {label && (
        <label htmlFor={formSelectProps.id} className={labelClassname}>
          {label}
          {formSelectProps.required && <span className="text-danger"> *</span>}
        </label>
      )}
      {register && formSelectProps.name ? (
        <Form.Select
          className={`form-control ${selectClassName}`}
          {...formSelectProps}
          {...register(formSelectProps.name, registerOpt)}
        >
          {" "}
          {optionArr.map((opt, index) => (
            <option key={index} value={opt.value} defaultChecked={index === 0}>
              {opt.label || opt.value}
            </option>
          ))}
        </Form.Select>
      ) : (
        <Form.Select
          className={`form-control ${selectClassName}`}
          {...formSelectProps}
        >
          {optionArr.map((opt, index) => (
            <option key={index} value={opt.value} defaultChecked={index === 0}>
              {opt.label || opt.value}
            </option>
          ))}
        </Form.Select>
      )}
    </div>
  );
};
